<template>
	<div>
		<component v-if="view" v-bind:is="component" :id="id"></component>
	</div>
</template>
<script>

	export default{
		name: "Post", 
		data: () => {
			return {
				type: false,
				id: false
			}
		},
		components: {
			"Scheduling": () => import('../components/tools/Scheduler'),	
			"Survey": () => import('../views/Survey'),	
			"DisplayPost": () => import('../components/singles/DisplayPost'),	
		},
		computed: {
			view: function(){
				return this.$store.state.auth.view;
			},
			component: function(){
				switch (this.type ){
					case "survey":
						return  "Survey";
					case "scheduling":
						return "Scheduling";
					case "post":
						return "DisplayPost";
					default:
						return "";
				}
			}, 
		},		
		mounted: function(){
			const self = this;
			var namedPath = self.$route.params.namedPath;
			self.$store.dispatch("getDoc", {
				doc: "namedUrls/"+ namedPath,
			}).then( (doc) => {				
				if( doc ){
					self.id = doc.objectId;
					self.type = doc.type
					self.$route.params.id = self.id;
				}
				else{
					self.$router.replace({ name: "home" });
				}
			} )				
			
		
		}
	}
</script>